export default {
  /**
   * リピート推移向け期間条件フォーマット
   *
   * 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（週:w / 月:m）
       */
      termType: 'w',
      /**
       * 開始日
       */
      dateFrom: undefined,
      /**
       * 終了日
       */
      dateTo: undefined,
      /**
       * 週単位数
       */
      weekCount: 1,
      /**
       * 週期間数
       */
      weekTerm: 13,
      /**
       * 月単位数
       */
      monthCount: 1,
      /**
       * 月期間数
       */
      monthTerm: 12,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    if (term.termType === 'w') {
      return {
        termType: term.termType,
        dateFrom: term.dateFrom,
        dateTo: term.dateTo,
        dateUnit: term.weekCount,
      }
    } else if (term.termType === 'm') {
      return {
        termType: term.termType,
        dateFrom: term.dateFrom,
        dateTo: term.dateTo,
        dateUnit: term.monthCount,
      }
    }

    throw new Error(`unknown term select type: ${term.termType}`)
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, term) {
    // Lionパターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.termType = term.termType
    applyTo.dateFrom = term.dateFrom
    applyTo.dateTo = term.dateTo
    applyTo.weekCount = term.weekCount
    applyTo.weekTerm = term.weekTerm
    applyTo.monthCount = term.monthCount
    applyTo.monthTerm = term.monthTerm
  },
}
